module.exports = "<p>desing-test works!</p>\n"